import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "component-variable__footer component-variable__footer--error" };
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("span", { class: "component-variable__footer__prefix" }, [
    /*#__PURE__*/ _createElementVNode("i", { class: "fa-solid fa-diamond-exclamation" })
], -1 /* HOISTED */);
const _hoisted_3 = { class: "component-variable__footer__message" };
const _hoisted_4 = { class: "component-variable__footer__controls" };
import Tooltip from "src/shared/v-components/ui/Tooltip.vue";
import { computed } from "vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ComponentVariableErrorFooter',
    props: {
        error: {}
    },
    emits: ["reset"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const errorMessage = computed(() => {
            return (props.error.parameters.details ||
                props.error.message ||
                "An error occurred");
        });
        // emit reset event
        const emit = __emit;
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _hoisted_2,
                _createElementVNode("span", _hoisted_3, _toDisplayString(errorMessage.value), 1 /* TEXT */),
                _createElementVNode("span", _hoisted_4, [
                    _createVNode(Tooltip, { message: 'Discard Changes' }, {
                        default: _withCtx(() => [
                            _createElementVNode("i", {
                                class: "fa fa-undo",
                                onClick: _cache[0] || (_cache[0] = ($event) => (emit('reset')))
                            })
                        ]),
                        _: 1 /* STABLE */
                    })
                ])
            ]));
        };
    }
});
